import {NodeSpec} from 'prosemirror-model';

export const math_display: NodeSpec = {
    group: 'block',
    atom: true,
    attrs: {latex: {default: ''}},
    parseDOM: [{
        tag: 'div[data-math-display]',
        getAttrs: (dom) => ({latex: (dom as HTMLElement).getAttribute('data-math-display') ?? ''}),
    }],
    toDOM: (node) => ['div', {'data-math-display': node.attrs.latex}],
};
